import { render, staticRenderFns } from "./TrademarkSearchOwnerForm.vue?vue&type=template&id=01f5c5b4&"
import script from "./TrademarkSearchOwnerForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchOwnerForm.vue?vue&type=style&index=0&id=01f5c5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports